// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ReleasePOsStepQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ReleasePOsStepQuery = { __typename?: 'Query', bidContractRevision: { __typename?: 'BidContractRevision', id: string, commitments: Array<{ __typename?: 'Commitment', id: string, accountingNumber: number, committedInCents: number, taxableCostInCents: number, status: Types.CommitmentStatus, statusText: string, releaseWhenReady?: boolean | null | undefined, project:
        | { __typename?: 'StandaloneProject', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
              | { __typename?: 'ReadyPlan', id: string, displayName: string }
              | { __typename?: 'PlanPackage', id: string, displayName: string }
              | { __typename?: 'DesignPackage', id: string, displayName: string }
              | { __typename?: 'ProductOffering', id: string, displayName: string }
             | null | undefined } | null | undefined }
        | { __typename?: 'Region', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
              | { __typename?: 'ReadyPlan', id: string, displayName: string }
              | { __typename?: 'PlanPackage', id: string, displayName: string }
              | { __typename?: 'DesignPackage', id: string, displayName: string }
              | { __typename?: 'ProductOffering', id: string, displayName: string }
             | null | undefined } | null | undefined }
        | { __typename?: 'Market', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
              | { __typename?: 'ReadyPlan', id: string, displayName: string }
              | { __typename?: 'PlanPackage', id: string, displayName: string }
              | { __typename?: 'DesignPackage', id: string, displayName: string }
              | { __typename?: 'ProductOffering', id: string, displayName: string }
             | null | undefined } | null | undefined }
        | { __typename?: 'Community', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
              | { __typename?: 'ReadyPlan', id: string, displayName: string }
              | { __typename?: 'PlanPackage', id: string, displayName: string }
              | { __typename?: 'DesignPackage', id: string, displayName: string }
              | { __typename?: 'ProductOffering', id: string, displayName: string }
             | null | undefined } | null | undefined }
        | { __typename?: 'Subdivision', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
              | { __typename?: 'ReadyPlan', id: string, displayName: string }
              | { __typename?: 'PlanPackage', id: string, displayName: string }
              | { __typename?: 'DesignPackage', id: string, displayName: string }
              | { __typename?: 'ProductOffering', id: string, displayName: string }
             | null | undefined } | null | undefined }
        | { __typename?: 'Lot', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
              | { __typename?: 'ReadyPlan', id: string, displayName: string }
              | { __typename?: 'PlanPackage', id: string, displayName: string }
              | { __typename?: 'DesignPackage', id: string, displayName: string }
              | { __typename?: 'ProductOffering', id: string, displayName: string }
             | null | undefined } | null | undefined }
        | { __typename?: 'Structure', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
              | { __typename?: 'ReadyPlan', id: string, displayName: string }
              | { __typename?: 'PlanPackage', id: string, displayName: string }
              | { __typename?: 'DesignPackage', id: string, displayName: string }
              | { __typename?: 'ProductOffering', id: string, displayName: string }
             | null | undefined } | null | undefined }
        | { __typename?: 'Unit', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
              | { __typename?: 'ReadyPlan', id: string, displayName: string }
              | { __typename?: 'PlanPackage', id: string, displayName: string }
              | { __typename?: 'DesignPackage', id: string, displayName: string }
              | { __typename?: 'ProductOffering', id: string, displayName: string }
             | null | undefined } | null | undefined }
      , costCodes: Array<{ __typename?: 'CostCode', id: string, number: string }>, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, bidContractRevision?: { __typename?: 'BidContractRevision', id: string, version: string } | null | undefined, voidsCommitments: Array<{ __typename?: 'Commitment', id: string, committedInCents: number }>, changeEvent?: { __typename?: 'ChangeEvent', id: string, status: Types.ChangeEventStatus } | null | undefined }> } };

export type UpdateCommitmentAutoReleaseStatusMutationVariables = Types.Exact<{
  commitmentReleaseFlagUpdates: Array<Types.SaveCommitmentInput> | Types.SaveCommitmentInput;
  commitmentsToReleaseNow: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  skipRelease: Types.Scalars['Boolean']['input'];
}>;


export type UpdateCommitmentAutoReleaseStatusMutation = { __typename?: 'Mutation', saveCommitments: { __typename?: 'SaveCommitmentsResult', commitments: Array<{ __typename?: 'Commitment', id: string }> }, releaseBidCommitments?: Array<
    | { __typename?: 'Commitment', id: string }
    | { __typename?: 'CommitmentChangeOrder', id: string }
  > };

export type ReleasePOsStep_CommitmentFragment = { __typename?: 'Commitment', id: string, accountingNumber: number, committedInCents: number, taxableCostInCents: number, status: Types.CommitmentStatus, statusText: string, releaseWhenReady?: boolean | null | undefined, project:
    | { __typename?: 'StandaloneProject', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
    | { __typename?: 'Region', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
    | { __typename?: 'Market', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
    | { __typename?: 'Community', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
    | { __typename?: 'Subdivision', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
    | { __typename?: 'Lot', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
    | { __typename?: 'Structure', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
    | { __typename?: 'Unit', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, displayName: string }
          | { __typename?: 'PlanPackage', id: string, displayName: string }
          | { __typename?: 'DesignPackage', id: string, displayName: string }
          | { __typename?: 'ProductOffering', id: string, displayName: string }
         | null | undefined } | null | undefined }
  , costCodes: Array<{ __typename?: 'CostCode', id: string, number: string }>, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, bidContractRevision?: { __typename?: 'BidContractRevision', id: string, version: string } | null | undefined, voidsCommitments: Array<{ __typename?: 'Commitment', id: string, committedInCents: number }>, changeEvent?: { __typename?: 'ChangeEvent', id: string, status: Types.ChangeEventStatus } | null | undefined };

export const ReleasePOsStep_CommitmentFragmentDoc = gql`
    fragment ReleasePOsStep_Commitment on Commitment {
  id
  accountingNumber
  project {
    id
    name
    readyPlanConfig {
      id
      readyPlan {
        id
        displayName
      }
    }
  }
  costCodes {
    id
    number
  }
  tradePartner {
    id
    name
  }
  bidContractRevision {
    id
    version
  }
  voidsCommitments {
    id
    committedInCents
  }
  committedInCents
  taxableCostInCents
  status
  statusText
  changeEvent {
    id
    status
  }
  releaseWhenReady
}
    `;
export const ReleasePOsStepDocument = gql`
    query ReleasePOsStep($id: ID!) {
  bidContractRevision(id: $id) {
    id
    commitments {
      id
      ...ReleasePOsStep_Commitment
    }
  }
}
    ${ReleasePOsStep_CommitmentFragmentDoc}`;

/**
 * __useReleasePOsStepQuery__
 *
 * To run a query within a React component, call `useReleasePOsStepQuery` and pass it any options that fit your needs.
 * When your component renders, `useReleasePOsStepQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReleasePOsStepQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReleasePOsStepQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReleasePOsStepQuery, ReleasePOsStepQueryVariables> & ({ variables: ReleasePOsStepQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReleasePOsStepQuery, ReleasePOsStepQueryVariables>(ReleasePOsStepDocument, options);
      }
export function useReleasePOsStepLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReleasePOsStepQuery, ReleasePOsStepQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReleasePOsStepQuery, ReleasePOsStepQueryVariables>(ReleasePOsStepDocument, options);
        }
// @ts-ignore
export function useReleasePOsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReleasePOsStepQuery, ReleasePOsStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReleasePOsStepQuery, ReleasePOsStepQueryVariables>;
export function useReleasePOsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReleasePOsStepQuery, ReleasePOsStepQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReleasePOsStepQuery | undefined, ReleasePOsStepQueryVariables>;
export function useReleasePOsStepSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReleasePOsStepQuery, ReleasePOsStepQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReleasePOsStepQuery, ReleasePOsStepQueryVariables>(ReleasePOsStepDocument, options);
        }
export type ReleasePOsStepQueryHookResult = ReturnType<typeof useReleasePOsStepQuery>;
export type ReleasePOsStepLazyQueryHookResult = ReturnType<typeof useReleasePOsStepLazyQuery>;
export type ReleasePOsStepSuspenseQueryHookResult = ReturnType<typeof useReleasePOsStepSuspenseQuery>;
export type ReleasePOsStepQueryResult = Apollo.QueryResult<ReleasePOsStepQuery, ReleasePOsStepQueryVariables>;
export const UpdateCommitmentAutoReleaseStatusDocument = gql`
    mutation UpdateCommitmentAutoReleaseStatus($commitmentReleaseFlagUpdates: [SaveCommitmentInput!]!, $commitmentsToReleaseNow: [ID!]!, $skipRelease: Boolean!) {
  saveCommitments(input: $commitmentReleaseFlagUpdates) {
    commitments {
      id
    }
  }
  releaseBidCommitments(commitmentLikeIds: $commitmentsToReleaseNow) @skip(if: $skipRelease) {
    id
  }
}
    `;
export type UpdateCommitmentAutoReleaseStatusMutationFn = Apollo.MutationFunction<UpdateCommitmentAutoReleaseStatusMutation, UpdateCommitmentAutoReleaseStatusMutationVariables>;

/**
 * __useUpdateCommitmentAutoReleaseStatusMutation__
 *
 * To run a mutation, you first call `useUpdateCommitmentAutoReleaseStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommitmentAutoReleaseStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommitmentAutoReleaseStatusMutation, { data, loading, error }] = useUpdateCommitmentAutoReleaseStatusMutation({
 *   variables: {
 *      commitmentReleaseFlagUpdates: // value for 'commitmentReleaseFlagUpdates'
 *      commitmentsToReleaseNow: // value for 'commitmentsToReleaseNow'
 *      skipRelease: // value for 'skipRelease'
 *   },
 * });
 */
export function useUpdateCommitmentAutoReleaseStatusMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCommitmentAutoReleaseStatusMutation, UpdateCommitmentAutoReleaseStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCommitmentAutoReleaseStatusMutation, UpdateCommitmentAutoReleaseStatusMutationVariables>(UpdateCommitmentAutoReleaseStatusDocument, options);
      }
export type UpdateCommitmentAutoReleaseStatusMutationHookResult = ReturnType<typeof useUpdateCommitmentAutoReleaseStatusMutation>;
export type UpdateCommitmentAutoReleaseStatusMutationResult = Apollo.MutationResult<UpdateCommitmentAutoReleaseStatusMutation>;
export type UpdateCommitmentAutoReleaseStatusMutationOptions = Apollo.BaseMutationOptions<UpdateCommitmentAutoReleaseStatusMutation, UpdateCommitmentAutoReleaseStatusMutationVariables>;